<div class="debug-panel">
  <div class="debug-row">
    <span class="label">Player state</span>
    <span class="value">{{ playerState || '—' }}</span>
  </div>
  <div class="debug-row">
    <span class="label">Game state</span>
    <span class="value">{{ gameState }}</span>
  </div>
  <div class="debug-row">
    <span class="label">Wanted level</span>
    <div class="row-controls">
      <button class="btn-sm" (click)="decreaseWantedLevel()">-</button>
      <button class="btn-sm" (click)="increaseWantedLevel()">+</button>
    </div>
    <span class="value">{{ wantedLevel }}</span>
  </div>
  <div class="debug-row">
    <span class="label">Pursuer LoS</span>
    <span class="value">{{ anyPursuerHasLoS ? 'yes' : 'no' }}</span>
  </div>
  <div class="debug-row">
    <span class="label">Escape countdown</span>
    <span class="value">{{ escapeCountdown !== null ? (escapeCountdown | number:'1.0-0') + 's' : '—' }}</span>
  </div>
  <div class="debug-row">
    <span class="label">Debug Navmesh</span>
    <button class="toggle" [class.on]="worldService.navmeshDebugEnabled" (click)="toggleNavmesh()">
      <span class="knob"></span>
    </button>
  </div>
  <div class="debug-row">
    <span class="label">Debug Collision</span>
    <button class="toggle" [class.on]="worldService.collisionDebugEnabled" (click)="toggleCollision()">
      <span class="knob"></span>
    </button>
  </div>
  <div class="debug-row">
    <span class="label">Ragdoll</span>
    <button class="toggle" [class.on]="worldService.ragdollDebugEnabled" (click)="toggleRagdoll()">
      <span class="knob"></span>
    </button>
  </div>
  <div class="debug-row" *ngFor="let bone of worldService.ragdollBoneNames">
    <span class="label">{{ bone }}</span>
    <button class="toggle" [class.on]="worldService.isBoneEnabled(bone)" (click)="toggleRagdollBone(bone)">
      <span class="knob"></span>
    </button>
  </div>
</div>
